module.exports = __webpack_public_path__ + "34b645f277dc9212861a44920075ec93.svg";